import React from 'react'

function ViewHeader({ children }) {
    return <header className="ao-view__header">{ children }</header>
}

export default ViewHeader